/**
 * Permissions available in the system.
 * This should be kept in sync with the backend Permission enum.
 */
export enum Permission {
  /** View Players, Teams, Games, Templates, Template Store, Mediathek, Sponsors */
  READ_ENTITIES = 'READ_ENTITIES',

  /** Manage Billing details */
  MANAGE_BILLING = 'MANAGE_BILLING',

  /** Upload/Edit Mediathek (Organization and Store) */
  MANAGE_MEDIA_LIBRARY = 'MANAGE_MEDIA_LIBRARY',

  /**
   * Create and edit Players, Teams, Games, Sponsors, Agreements
   * Import/Edit Templates from Store
   */
  MANAGE_ENTITIES = 'MANAGE_ENTITIES',

  /** Edit watermarks (requires PRO or INTERNAL) */
  EDIT_WATERMARKS = 'EDIT_WATERMARKS',

  /** Add watermarks (INTERNAL only) */
  ADD_WATERMARKS = 'ADD_WATERMARKS',

  /** Create, Edit, Delete, Add/Remove Elements for Customer Templates */
  MANAGE_CUSTOMER_TEMPLATE = 'MANAGE_CUSTOMER_TEMPLATE',

  /** Store Templates, Store Mediathek (read, write) */
  MANAGE_TEMPLATE_STORE = 'MANAGE_TEMPLATE_STORE',

  /** Manage Integrations (e.g., WhatsApp, Meta) */
  MANAGE_INTEGRATIONS = 'MANAGE_INTEGRATIONS',

  /** Generate AI-powered captions for posts (requires PRO or INTERNAL) */
  GENERATE_AI_CAPTIONS = 'GENERATE_AI_CAPTIONS',

  /** View and Edit Organization Members, Roles, Branding, and Data */
  MANAGE_ORGANIZATION = 'MANAGE_ORGANIZATION',

  /** Manage Customers (INTERNAL ADMIN only) */
  MANAGE_CUSTOMERS = 'MANAGE_CUSTOMERS',

  /** Read Customers (INTERNAL only) */
  READ_CUSTOMERS = 'READ_CUSTOMERS',

  /** Manage Internal Users (INTERNAL ADMIN only) */
  MANAGE_INTERNAL_USERS = 'MANAGE_INTERNAL_USERS',

  /** Read Internal Users (INTERNAL only) */
  READ_INTERNAL_USERS = 'READ_INTERNAL_USERS',
}
